import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Avatar, ListItemAvatar } from '@material-ui/core';

import { upperCaseSubstring } from '../../../../../shared/utility';
import useTrainStationListItemStyles from './useTrainStationListItemStyles';

const TrainStationListItem = (props) => {
    const {
        stopId,
        stopName, 
        destination, 
        onStationClick 
    } = props;
    const classes = useTrainStationListItemStyles(props);

    const onStationClickHandler = () => {
        onStationClick({
            stopId: stopId,
            stopName: stopName
        });
    };

    const secondaryText = `#${stopId} - ${destination}`;
    const avatarText = upperCaseSubstring(stopName, 0, 1);

    return (
        <ListItem button onClick={onStationClickHandler}>
            <ListItemAvatar>
                <Avatar className={classes.avatar}>
                    {avatarText}
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={stopName} secondary={secondaryText}/>
        </ListItem>
    );
}

export default TrainStationListItem;